
import { Options, Vue } from 'vue-class-component';
import { CourseProduct, Product } from "@/data/products";
import CourseService from "@/services/CourseService";
import { formatPrice } from "@/utils/helpers";
import ProductCard from "@/components/ProductCard.vue";
import ProductOrderPaymentModal from "@/components/modals/ProductOrderPaymentModal.vue";
import { RecordIdentifier } from "@/data/global";
import { Course } from "@/data/course";

@Options({
    props: {
        course: {
            type: Object,
            required: true,
            validator: (value: any) => {
                return value?.mode === 1; // mode 1 => closed course
            },
        },
        classes: {
            type: Object,
            required: false,
            default: {},
        },
    },
    methods: {
        formatPrice,
    },
    components: {
        ProductCard,
        ProductOrderPaymentModal,
    },
    emits: [
        'orderSuccess'
    ],
})
export default class CourseOrderable extends Vue {
    course!: Course
    // regionName!: string|null
    classes!: Record<string, boolean>

    modalShown = false

    get product() : CourseProduct {
        return CourseService.buildCourseProduct({
            course_id: this.course.id,
            region_id:this.course.region_id,
            price: this.course.fee as number,
            course: this.course,
        });
    }

    onOrderSuccess() {
        this.$emit('orderSuccess');
    }

    mounted() {
        //
    }
}
